// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"108bf3f6","732":"658715f8"}[chunkId] + ".chunk.js";
};